var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine228(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 726,
    height: 146,
    viewBox: "0 0 726 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M726 144L528.751 14.0424C523.243 10.0283 505.825 2.00002 480.213 2.00002C454.602 2.00002 149.4 2.00005 -1.2414e-05 2.00006",
    stroke: "#221AFB",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine228);
export default __webpack_public_path__ + "static/media/line_228.74eb7eb958a7df88f2c36d1df44fb9cc.svg";
export { ForwardRef as ReactComponent };